import { render, staticRenderFns } from "./reportFeeDetailList.vue?vue&type=template&id=1444b192&scoped=true"
import script from "./reportFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailList.vue?vue&type=style&index=0&id=1444b192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1444b192",
  null
  
)

export default component.exports